import React from "react";

function Deals() {
  return (
    <div className="space-y-6">

      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Deals Pipeline</h1>
        <p className="text-sm text-gray-500">
          Track deals through stages
        </p>
      </div>

      <div className="grid md:grid-cols-4 gap-4">

        {/* Stage Column */}
        {["Lead", "Qualified", "Proposal", "Won"].map((stage) => (
          <div key={stage} className="bg-gray-100 rounded-xl p-4">
            <h3 className="font-semibold text-gray-700 mb-4">
              {stage}
            </h3>

            <div className="space-y-3">
              <div className="bg-white rounded-lg p-3 shadow-sm">
                <p className="font-medium">Website Project</p>
                <p className="text-sm text-gray-500">$2,500</p>
              </div>

              <div className="bg-white rounded-lg p-3 shadow-sm">
                <p className="font-medium">CRM System</p>
                <p className="text-sm text-gray-500">$4,000</p>
              </div>
            </div>
          </div>
        ))}

      </div>

    </div>
  );
}

export default Deals;
